import { useBexApi } from '@shared-ui/bex-api-context';
import React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { GenericErrorMessage } from '../common/generic-error-message';
import {
  DocumentQueryResult,
  DocumentationDocumentSuccessResponse,
  useDocumentQuery,
} from '../../graphql/__generated__/types';
import { ErrorBoundary } from 'bernie-view';
import EgMarkdownRenderer from '@eg-markdown-renderer/core';
import { useMarkdownRendererOptions } from '../../hooks/useMarkdownRendererOptions';
import useNavigationParams from '../../hooks/useNavigationParams';

export const FOOTER_DOCUMENT_ID = '_common/footer';
const Footer = () => {
  const { hubId } = useNavigationParams();
  const { componentsOptions } = useMarkdownRendererOptions(hubId);
  const { context } = useBexApi();

  const { data, loading, error } = useDocumentQuery({
    variables: { context, hubId, documentId: FOOTER_DOCUMENT_ID },
  }) as DocumentQueryResult;

  const isErrorDataResponse = data?.documentation.document.__typename === 'DocumentationDocumentErrorResponse';

  if (!data || loading || error || isErrorDataResponse) {
    return null;
  }

  const { content } = data.documentation.document as unknown as DocumentationDocumentSuccessResponse;

  return (
    <UitkSpacing padding={{ blockstart: 'sixteen', blockend: 'twelve' }}>
      <div>
        <UitkSpacing margin={{ inline: 'half', block: 'sixteen' }}>
          <ErrorBoundary label="document.body" key="document.body" fallback={<GenericErrorMessage />}>
            <div className="md-renderer-wrapper uitk-type-center footer">
              <EgMarkdownRenderer mdBody={content} componentsOptions={componentsOptions} />
            </div>
          </ErrorBoundary>
        </UitkSpacing>
      </div>
    </UitkSpacing>
  );
};

export default Footer;
